import React from "react";
import { X, Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { WITHOUT_KATLAS, WITH_KATLAS, CHANGE_CONCLUSION } from "./data";

export default function WhatChanges() {
  return (
    <section className="section section--change" id="change">
      <div className="wrap">
        <Reveal>
          <div className="sec-head">
            <span className="sec-kicker">What changes for me</span>
            <h2 className="sec-title">The same exception — a different day.</h2>
          </div>
        </Reveal>

        <div className="ba" data-testid="before-after">
          <Reveal className="ba__col ba__col--without">
            <span className="ba__tag ba__tag--without">Without KATLAS</span>
            <ul>
              {WITHOUT_KATLAS.map((t, i) => (
                <li key={i} data-testid={"without-" + i}><X size={15} className="ba__icon" /> {t}</li>
              ))}
            </ul>
          </Reveal>
          <Reveal className="ba__col ba__col--with" delay={0.1}>
            <span className="ba__tag ba__tag--with">With KATLAS</span>
            <ul>
              {WITH_KATLAS.map((t, i) => (
                <li key={i} data-testid={"with-" + i}><Check size={15} className="ba__icon" /> {t}</li>
              ))}
            </ul>
          </Reveal>
        </div>

        <Reveal>
          <p className="change-conclusion" data-testid="change-conclusion">{CHANGE_CONCLUSION}</p>
        </Reveal>
      </div>
    </section>
  );
}
